module.exports = __webpack_public_path__ + "img/couponO.989e0399.png";